import {createFixedLayerId} from '@gaia/utils/mapbox/concatMapboxStyles';

// `concatMapboxStyle` overwrites layer ids to avoid name collisions. But layers that we access
// programmatically need to have a statically known id.

// `concatMapboxStyle` knows to not overwrite the following "fixed" layer ids. And Typescript can
// ensure that only known fixed layer ids are accessed programmatically.

export const trackFixedLayerIds = {
    remoteUserTracks: {
        casing: createFixedLayerId(),
        line: createFixedLayerId(),
        directionArrow: createFixedLayerId(),
    },
    localUser: {
        casing: createFixedLayerId(),
        directionArrow: createFixedLayerId(),
        normal: createFixedLayerId(),
        preview: createFixedLayerId(),
        loading: createFixedLayerId(),
        focused: createFixedLayerId(),
        focusedShadow: createFixedLayerId(),
    },
    editing: {
        point: createFixedLayerId(),
        normalCasing: createFixedLayerId(),
        previewCasing: createFixedLayerId(),
        directionArrow: createFixedLayerId(),
        normal: createFixedLayerId(),
        preview: createFixedLayerId(),
        loading: createFixedLayerId(),
    },
    remoteShared: {
        casing: createFixedLayerId(),
        line: createFixedLayerId(),
        directionArrow: createFixedLayerId(),
    },
    localShared: {
        point: createFixedLayerId(),
        casing: createFixedLayerId(),
        directionArrow: createFixedLayerId(),
        normal: createFixedLayerId(),
        preview: createFixedLayerId(),
        loading: createFixedLayerId(),
    },
};

export const publicTrackFixedLayerIds = {
    casing: createFixedLayerId(),
    line: createFixedLayerId(),
    symbol: createFixedLayerId(),
};

export const waypointFixedLayerIds = {
    embeddedMap: createFixedLayerId(),
    remoteUser: {
        pin: createFixedLayerId(),
    },
    localUser: {
        pin: createFixedLayerId(),
        circle: createFixedLayerId(),
    },
    remoteShared: {
        pin: createFixedLayerId(),
    },
    localShared: {
        pin: createFixedLayerId(),
        circle: createFixedLayerId(),
    },
    editingWaypoint: {
        pin: createFixedLayerId(),
        circle: createFixedLayerId(),
    },
};

export const areaFixedLayerIds = {
    remoteUser: {
        line: createFixedLayerId(),
        fill: createFixedLayerId(),
    },
    localUser: {
        line: createFixedLayerId(),
        fill: createFixedLayerId(),
        point: createFixedLayerId(),
        symbol: createFixedLayerId(),
    },
    remoteShared: {
        line: createFixedLayerId(),
        fill: createFixedLayerId(),
    },
    localShared: {
        line: createFixedLayerId(),
        fill: createFixedLayerId(),
        symbol: createFixedLayerId(),
    },
    editingArea: {
        line: createFixedLayerId(),
        fill: createFixedLayerId(),
        point: createFixedLayerId(),
        symbol: createFixedLayerId(),
    },
};

export const knownRouteFixedLayerIds = {
    saved: createFixedLayerId(),
    focused: createFixedLayerId(),
    focusedShadow: createFixedLayerId(),
};

export const osmSelectionFixedLayerIds = {
    symbol: createFixedLayerId(),
    symbolShadow: createFixedLayerId(),
    line: createFixedLayerId(),
    lineShadow: createFixedLayerId(),
    landLine: createFixedLayerId(),
    landFill: createFixedLayerId(),
    landShadow: createFixedLayerId(),
};
